import styles from './productName.module.css'
import { Lot, Product } from '../../../state/types'
import { Supplier, useSupplierLoaders } from '../../../../purchases'
import { NO_LOT } from '../../../utils/lotUtils'
import { Badge, O } from '../../../../../features/ui'
import { useEffect, useState } from 'react'

type Props = {
    product?: Product
    lot?: Partial<Lot>
    showCode?: boolean
    showSupplierCode?: boolean
}

export const ProductName = (props: Props) => {
    const { product, lot, showCode, showSupplierCode } = props
    
    const [supplier, setSupplier] = useState<O<Supplier>>()
    const supplierLoaders = useSupplierLoaders()

    useEffect(() => {
        product?.supplierId && supplierLoaders().loadSupplier(product.supplierId).then(setSupplier)
    }, [product?.supplierId])

    if (!product || !supplier) {
        return <></>
    }

    const codeLabel = `(#${product.code}) `
    const supplierCodeLabel = ` (${product.supplierCode}) `
    const lotLabel = lot?.code === NO_LOT ? lot.code : `Partida: ${lot?.code}`

    return (
        <div className={styles.container}>
            {showCode && codeLabel}
            {product.name}
            {showSupplierCode && supplierCodeLabel}
            {product.loted && lot && (
                <Badge
                    label={lotLabel}
                    small
                    className={styles.badge}
                />
            )}
            <Badge
                label={supplier.name}
                small
                className={styles.badge}
            />
        </div>
    )
}
